// extracted by mini-css-extract-plugin
export default {"btnContainer":"Payments_btnContainer__br25D"};